import camelCase from 'lodash/camelCase';

/**
 *
 * @param {string} css - A string of CSS
 * @return {object} A camelCased CSS style object
 *
 */

const toStyleObject = css => {
  if (typeof css !== 'string') {
    return null;
  }

  const rules = css.trim().split(';');

  if (!rules.length) {
    return null;
  }

  const styleObject = rules.reduce((object, attribute) => {
    const [key, value] = attribute.split(':');

    if (typeof value !== 'string' || !value.trim() || !key.trim()) {
      return object;
    }

    return {
      ...object,
      [camelCase(key.trim())]: value.trim(),
    };
  }, {});

  return Object.keys(styleObject).length ? styleObject : null;
};

export default toStyleObject;
